import { apiService } from "api/apiService";
import type {
  MyStudentsActionplansCounts200,
  FilterResource,
  TeacherActionplanBatchResource,
} from "api/generated";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import { actionplanBatchFromDto } from "actionplan/api/mappers";
import type { ActionplanBatch, ActionplanTabCounts } from "actionplan/types";
import { mapFilters } from "shared/mappers";
import type { Filter } from "shared/types";

export const fetchMentorClassActionplans = async (
  mentorClass: string,
  params: Record<string, string> = {},
): Promise<PaginatedResult<ActionplanBatch>> => {
  const { data } = await apiService.get<
    PaginatedResponse<TeacherActionplanBatchResource>
  >(`api/my-students/${encodeURIComponent(mentorClass)}/actionplans`, {
    params,
  });

  return mapPaginatedResponse(data, actionplanBatchFromDto);
};

export const fetchMentorClassActionplanCounts = async (
  mentorClass: string,
  params: Record<string, string> = {},
): Promise<ActionplanTabCounts> => {
  const { data } = await apiService.get<MyStudentsActionplansCounts200>(
    `api/my-students/${encodeURIComponent(mentorClass)}/actionplans/counts`,
    { params },
  );

  return data;
};

export const fetchMentorClassActionplanFilters = async (
  mentorClass: string,
): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/my-students/${encodeURIComponent(mentorClass)}/actionplans/filters`,
  );

  return mapFilters(filters);
};
